module.exports = __webpack_public_path__ + "src/assets/img/abbinder_de.024f9b04.svg";